var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    ref: "table",
    staticClass: "q-mt-lg",
    attrs: {
      data: _vm.participants,
      columns: _vm.columns,
      filter: _vm.filter,
      "row-key": "id",
      pagination: _vm.pagination,
      loading: _vm.loading,
      "no-data-label": _vm.$t("no_data_avaliable"),
      "no-results-label": _vm.$t("no_results_found"),
      "loading-label": _vm.$t("loading_data"),
      "rows-per-page-label": _vm.$t("items_per_page"),
      "rows-per-page-options": [5, 10, 50, 100],
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      },
      request: _vm.requestParticipants
    },
    scopedSlots: _vm._u([
      {
        key: "top",
        fn: function(props) {
          return [
            _c("q-search", {
              attrs: {
                icon: "fas fa-search",
                placeholder: _vm.$t("search"),
                debounce: 500
              },
              model: {
                value: _vm.filter,
                callback: function($$v) {
                  _vm.filter = $$v
                },
                expression: "filter"
              }
            }),
            _c("div", { staticClass: "col" }),
            _c("q-btn", {
              attrs: {
                color: "secondary q-mr-md",
                icon: "fas fa-download",
                label: _vm.$t("session_report")
              },
              on: {
                click: function($event) {
                  return _vm.downloadSessionReport()
                }
              }
            }),
            _c("q-btn", {
              attrs: {
                color: "secondary q-mr-md",
                icon: "fas fa-download",
                label: _vm.$t("certified_report")
              },
              on: {
                click: function($event) {
                  return _vm.downloadCertificateReport()
                }
              }
            }),
            _c("q-btn", {
              attrs: {
                color: "secondary",
                icon: "fas fa-download",
                label: _vm.$t("chat_report")
              },
              on: {
                click: function($event) {
                  return _vm.downloadChatReport()
                }
              }
            })
          ]
        }
      },
      {
        key: "header",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            _vm._l(props.cols, function(col) {
              return _c("q-th", { key: col.name, attrs: { props: props } }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.$t(col.label)) + "\n        "
                )
              ])
            }),
            1
          )
        }
      },
      {
        key: "body",
        fn: function(props) {
          return [
            _c(
              "q-tr",
              { attrs: { props: props } },
              [
                _c("q-td", { key: "user_full_name", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.user_full_name) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "user_email", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.user_email) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "user_profile", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.user_profile) +
                      "\n            "
                  )
                ]),
                _c(
                  "q-td",
                  { key: "total_watch_time", attrs: { props: props } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.fTime(props.row.total_watch_time)) +
                        "\n            "
                    )
                  ]
                ),
                _c(
                  "q-td",
                  { key: "watch_percentage", attrs: { props: props } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.watch_percentage) +
                        "%\n            "
                    )
                  ]
                ),
                _c("q-td", { key: "result_date", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.fDate(props.row.result_date)) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "percent", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        props.row.percent
                          ? props.row.percent.toFixed() + "%"
                          : ""
                      ) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "origin", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.origin) +
                      "\n            "
                  )
                ]),
                _c(
                  "q-td",
                  { key: "branches", attrs: { props: props } },
                  [
                    _c(
                      "q-btn",
                      {
                        attrs: {
                          color: "primary",
                          "text-color": "white",
                          label: props.row.branches.length,
                          "no-ripple": ""
                        }
                      },
                      [
                        _c("q-tooltip", [
                          props.row.branches.length > 0
                            ? _c(
                                "p",
                                { staticClass: "tooltip q-mb-sm" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("branches")) +
                                      ":\n                            "
                                  ),
                                  _vm._l(props.row.branches, function(
                                    branche,
                                    index
                                  ) {
                                    return _c("span", { key: index }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(branche) +
                                          "\n                                "
                                      ),
                                      props.row.branches.length - 1 > index
                                        ? _c("span", [_vm._v(", ")])
                                        : _vm._e()
                                    ])
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "q-td",
                  { key: "status", attrs: { props: props, "auto-width": "" } },
                  [
                    props.row.status
                      ? _c(
                          "q-chip",
                          {
                            staticClass: "full-width text-center",
                            attrs: {
                              small: "",
                              icon: _vm.getIconStatusUser(props.row.status),
                              color: _vm.getColorStatusUser(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.getTextStatusUser(props.row.status)
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }